/** Filete do fluxo Lunins — recorte próprio, não é a onda das peças de campanha. */
export default function FluxoRule({ className = '' }: { className?: string }) {
  return (
    <div className={`lunins-fluxo-rule ${className}`} aria-hidden>
      <svg viewBox="0 0 240 12" className="h-3 w-40 text-lunins-gold/70" fill="none">
        <path
          d="M1 8.5 C 38 2.5, 62 11, 96 6.5 S 168 1.5, 239 7"
          stroke="currentColor"
          strokeWidth="1.15"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
}
